// extracted by mini-css-extract-plugin
module.exports = {"dots":"Dots_dots__zrtys","dotbricks":"Dots_dotbricks__tbtZu","dot-bricks":"Dots_dot-bricks__ADzwk"};